import { Box, MenuItem, Select } from "@mui/material";
import Search from "../../../components/search/Search";
import { useSearchParams } from "react-router-dom";

const ticketStatuses = [
  { label: "باز", value: "open" },
  { label: "درحال بررسی", value: "pending" },
  { label: "پاسخ داده شده", value: "answered" },
  { label: "بسته شده", value: "closed" },
];

const TicketFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentFilter = searchParams.get("filter") || "all";

  const handleFilter = (e) => {
    const filter = e.target.value;
    const params = new URLSearchParams(searchParams);

    if (filter && filter !== "all") params.set("filter", filter);
    else params.delete("filter");
    setSearchParams(params);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <Search height={"36px"} placeholder={"جستجو : عنوان تیکت"} />

      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Select
          fullWidth
          value={currentFilter}
          onChange={handleFilter}
          sx={{ height: "36px" }}
        >
          <MenuItem value={"all"}>همه تیکت ها</MenuItem>
          {ticketStatuses.map((status) => (
            <MenuItem key={status.value} value={status.value}>
              {status.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default TicketFilters;
